var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52261_36164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 11.1667H8.66667C9.02029 11.1667 9.35943 11.0262 9.60948 10.7761C9.85952 10.5261 10 10.187 10 9.83333C10 9.47971 9.85952 9.14057 9.60948 8.89052C9.35943 8.64048 9.02029 8.5 8.66667 8.5H6.66667C6.26667 8.5 5.93333 8.63333 5.73333 8.9L2 12.5",
    stroke: "#67768E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 15.1682L5.73073 14.2348C5.93073 13.9682 6.26406 13.8348 6.66406 13.8348H9.33073C10.0641 13.8348 10.7307 13.5682 11.1974 13.0348L14.2641 10.1015C14.5213 9.85837 14.6715 9.52301 14.6815 9.1692C14.6915 8.81538 14.5605 8.47208 14.3174 8.21482C14.0743 7.95756 13.7389 7.80741 13.3851 7.79741C13.0313 7.78741 12.688 7.91837 12.4307 8.16148L9.63073 10.7615",
    stroke: "#67768E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 11.8281L5.33594 15.8281",
    stroke: "#67768E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5405 4.90625C7.85044 6.03544 9.00195 7.00391 8.43373 8.26307",
    stroke: "#67768E",
    strokeWidth: 1.00311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77306 4.59804C7.32767 5.00139 7.68061 5.70726 7.93271 6.46355C6.92432 6.66523 6.16803 6.66523 5.51258 6.3123C4.90755 6.00978 4.35294 5.35433 4 4.19468C5.41174 3.94259 6.21845 4.19468 6.77306 4.59804Z",
    stroke: "#67768E",
    strokeWidth: 1.00311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08772 2.88339C8.70332 3.48416 8.50996 4.1873 8.53311 4.90016C9.49108 4.84974 10.1969 4.59764 10.7011 4.19429C11.2053 3.6901 11.5079 3.03464 11.5583 1.875C10.1969 1.92542 9.5415 2.37919 9.08772 2.88339Z",
    stroke: "#67768E",
    strokeWidth: 1.00311,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52261_36164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.ca1cfd5b2454a22ecb4d37072bfda3e0.svg";
export { ForwardRef as ReactComponent };